import {connect} from 'react-redux'
import {ActionsRow, commons, field, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Alert, Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import * as polozkaActions from "../../actions/polozkaActions";
import TablePanel from "../../components/TablePanel";
import PolozkaApi from "../../api/gen/cgo/PolozkaApi";
import FakturacniPolozkaForm from "../../forms/FakturacniPolozkaForm";
import CustomCheckbox from "../../components/CustomCheckbox";
import * as opravneniActions from "../../actions/opravneniActions";
import * as EnumRole from "../../api/gen/cgo/EnumRole";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

const COLUMN_WIDTH = 2;

/**
 * Stránka administrace - Fakturační položky
 */
class FakturacniPolozkyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(polozkaActions.fetchFakturacniPolozkyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchSazbyDphIfNeeded());
    };

    handleCreatePolozka = () => {
        const {sazbyDphList, t} = this.props;
        const initialValues = {};
        if (sazbyDphList.fetched && sazbyDphList.rows.length > 0) {
            initialValues.danId = sazbyDphList.rows[0].id;
        }
        this.props.dispatch(modal.ModalActions.show(
            FakturacniPolozkaForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.createPolozka(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateFakturacniPolozky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues
            },
            t('new_billing_item'),
            {size: "md"}
        ));
    };

    handleEditPolozka = (polozka) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            FakturacniPolozkaForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.updatePolozka(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateFakturacniPolozky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: polozka
            },
            t('billing_items_change'),
            {size: "md"}
        ));
    };

    handleFulltextChange = (value) => {
        this.props.dispatch(polozkaActions.invalidateFakturacniPolozky()); //chceme nacitat vzdy znovu z DB
        const {fakturacniPolozkyList} = this.props;
        this.props.dispatch(polozkaActions.filterPolozky({
            ...fakturacniPolozkyList.filter,
            fulltext: value
        }, false));
    };

    handleClearFulltext = () => {
        this.handleFulltextChange("");
    };

    handleVcetneNeaktivnich = (e) => {
        const {fakturacniPolozkyList} = this.props;
        this.props.dispatch(polozkaActions.filterPolozky({
            ...fakturacniPolozkyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };


    renderContextMenu = (polozka) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditPolozka.bind(this, polozka))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {fakturacniPolozkyList, sazbyDphList, loggedInUser, t} = this.props;
        const extRezim = loggedInUser.data.extSystemRezim;
        const role = loggedInUser.data.role;

        let content;
        if (fakturacniPolozkyList.fetched && sazbyDphList.fetched) {
            if (fakturacniPolozkyList.rows.length !== 0) {
                content = fakturacniPolozkyList.rows.map(polozka => {
                    const dan = sazbyDphList.rows.find(s => s.id === polozka.danId);
                    return <CardBody key={polozka.id} className={polozka.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={role === EnumRole.ADMIN && !extRezim ? this.renderContextMenu(polozka) : null} onClick={role === EnumRole.ADMIN && !extRezim ? this.handleEditPolozka.bind(this, polozka) : null}>
                            <Row>
                                <Col xs={COLUMN_WIDTH}>{polozka.nazev}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.plu}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.cena}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.mj ? polozka.mj : "-"}</Col>
                                <Col xs={COLUMN_WIDTH}>{dan ? dan.nazevDph : "-"}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('no_billing_items')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }

        const vcetneNeaktivnich = fakturacniPolozkyList.filter.vcetneNeaktivnich || false;

        return <AdminPage
            title={t('admin.billing_items')}
            subtitle={t('admin.system_operator_billing_items')}
            content={
                <div>
                    <Row>
                        <Col xs={9}>
                            <ButtonToolbar>
                                {role === EnumRole.ADMIN && !extRezim && <Button color="primary" onClick={this.handleCreatePolozka}>{t('new_f')}</Button>}
                                <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                            </ButtonToolbar>
                        </Col>
                        <Col xs={3}>
                            <field.Search value={fakturacniPolozkyList.filter.fulltext} onChange={this.handleFulltextChange} placeholder={t('filter_items')} />
                        </Col>
                    </Row>
                    {fakturacniPolozkyList.filter.fulltext &&
                    <Alert color="info" isOpen toggle={this.handleClearFulltext}>{t('search_result',{vyraz: fakturacniPolozkyList.filter.fulltext})}</Alert>}
                    <TablePanel header={
                        <Row>
                            <Col xs={COLUMN_WIDTH}>{t('labels.name')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.PLU')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.price')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.unit')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.tax')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        fakturacniPolozkyList: utils.storeFromArea(state, polozkaActions.FAKTURACNI_POLOZKY_LIST_AREA),
        sazbyDphList: utils.storeFromArea(state, ciselnikActions.SAZBY_DPH_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(FakturacniPolozkyPage));

